import React, { useEffect } from 'react';
import OvertimeAgreementsReportDataTable from './OvertimeAgreementsReportDataTable';

const OvertimeAgreementsReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <OvertimeAgreementsReportDataTable rrhh={rrhh} />;
};

export default OvertimeAgreementsReportIndex;
